
/** @format */

import React, { useState, useEffect } from 'react';
import { useStyles } from '../style';
import TextItemDotted from '../../../components/TextItemDotted';
import { SimpleDialog, ButtonLoading } from 'components';
import { Grid, CircularProgress } from '@mui/material';
import Services from '../../../services/Services';
import { useNavigate } from 'react-router-dom';
import createToast from 'components/Toast/Toast';


const Filing = (props) => {
  const classes = useStyles();
  const { result } = props;
  const navigate = useNavigate();
  const [isOpenExportDG, setIsOpenExportDG] = useState(false);
  const [isloadProgress, setIsLoadProgress] = useState(false);
  useEffect(() => {
    if (result?.source?.isClosed === false &&
      result?.source?.error?.hasError === true &&
      result?.source?.warrantyStep === "FILING" &&
      result?.source?.warrantyStatus === 'ERROR') {
      setIsOpenExportDG(true)
    }
  }, [result])

  const retryRequest = async () => {
    setIsLoadProgress(true)
    const param = {
      'entity-id': result?.source?.entityId,
      'warrantySubStep': result?.source?.warrantySubStep,
    };
    Services.postWarrantiesRetry(result?.source?.entityId, param)
      .then((res) => {
        setIsLoadProgress(false);
        createToast('موفق', 'درخواست مجدد با موفقیت انجام شد', 'success');

        navigate('/Warranty/RequestList')
      })
      .catch((error) => {

        setIsLoadProgress(false);

      });
  };
  return (
    <>
      {result ? (

        <Grid container direction="row" alignItems="center" spacing={0} item xs={12}>
          <Grid className={classes.information}>
            <SimpleDialog
              onClose={() => setIsOpenExportDG(false)}
              fullWidth maxWidth="sm" open={isOpenExportDG} title="خطا در تشکیل پرونده">
              <Grid container style={{ textAlign: 'justify' }}>
                <p style={{ margin: '20px 0' }}>
                  {result?.source?.error?.message}
                </p>
              </Grid>
              <Grid style={{ display: 'flex', marginTop: '16px', flexDirection:'row-reverse' }}>

                <ButtonLoading
                  type="submit"
                  variant="contained"
                  color="primary"
                  loading={isloadProgress}
                  name=" درخواست مجدد"
                  onClick={() => retryRequest()}
                />
              </Grid>
            </SimpleDialog>

            {/* وضعیت منقضی شده  */}
            {result?.source?.warrantyStep === 'FILING' &&
              result?.source?.warrantyStatus === 'EXPIRED' ? (
              <Grid className={classes.blockCard}>
                <Grid className={classes.blockCardHeader}>
                  <h3 className={classes.blockCardTitle}>جزئیات و وضعیت تشکیل پرونده</h3>
                </Grid>
                {
                  <>

                    <TextItemDotted
                      title="تاریخ ایجاد"
                      title2={result?.source?.chequeInquiry?.dueDate}
                      isDate={true}
                    />

                  </>
                }

                <Grid className={classes.blockCardFooter}>
                  <h3 className={classes.blockCardFooterTitle}>
                    درخواست صدور ضمانت‌نامه منقضی شده است
                  </h3>
                </Grid>
              </Grid>
            ) : (
              ''
            )}

            {/* وضعیت در انتظار   */}
            {result?.source?.warrantyStep === 'FILING' &&
              result?.source?.warrantyStatus === 'WAITING' ? (
              <Grid className={classes.blockCard}>
                <Grid className={classes.blockCardHeader}>
                  <h3 className={classes.blockCardTitle}>جزئیات و وضعیت تشکیل پرونده</h3>
                </Grid>
                {
                  <>

                    <TextItemDotted
                      title="شماره پرونده"
                      title2={result?.source?.warrantyFileNumber}
                    />

                    <TextItemDotted
                      title="مبلغ کارمزد کسر شده"
                      title2={result?.source?.contract?.commissionPrice}
                      isPrice={true}
                    />

                  </>
                }

                <Grid className={classes.blockCardFooter}>
                  <h3 className={classes.blockCardFooterTitle}>
                    درخواست تشکیل پرونده در انتظار بررسی می باشد
                  </h3>
                </Grid>
              </Grid>
            ) : (
              ''
            )}


            {/* وضعیت  با موفقیت  */}
            {result?.source?.warrantyStep !== 'FILING' &&
              result?.source?.warrantyFileNumber ? (

              <Grid className={classes.blockCard}>
                <Grid className={classes.blockCardHeader}>
                  <h3 className={classes.blockCardTitle}>جزئیات و وضعیت تشکیل پرونده</h3>
                </Grid>
                {
                  <>
                    <TextItemDotted
                      title="شماره پرونده"
                      title2={result?.source?.warrantyFileNumber}
                    />

                    <TextItemDotted
                      title="مبلغ کارمزد کسر شده"
                      title2={result?.source?.contract?.commissionPrice}
                      isPrice={true}
                    />


                  </>
                }
                <Grid className={classes.blockCardFooter}>
                  <h3 className={classes.blockCardFooterTitle}>
                    تشکیل پرونده با موفقیت انجام شد.
                  </h3>
                </Grid>
              </Grid>

            ) : (
              ''
            )}


            {/* وضعیت خطا  */}
            {
              result?.source?.error?.hasError === true &&
                result?.source?.warrantyStep === "FILING" &&
                result?.source?.warrantyStatus === 'ERROR' ? (
                <Grid className={classes.blockCard}>
                  <Grid className={classes.blockCardHeader}>
                    <h3 className={classes.blockCardTitle}>جزئیات و وضعیت تشکیل پرونده</h3>
                  </Grid>
                  <TextItemDotted
                    title="شماره پرونده"
                    title2={result?.source?.warrantyFileNumber}
                  />
                  <Grid className={classes.blockCardFooter}>
                    <h3 className={classes.blockCardFooterTitle}>
                      درخواست با خطا مواجه شده است.
                    </h3>
                  </Grid>
                </Grid>
              ) : (
                ''
              )}

          </Grid>
        </Grid>
      ) : (
        result?.length !== 0 ? (
          <div className={classes.loadingFinger}>
            <CircularProgress color="inherit" size={30} />
          </div>
        ) : (
          ''
        )
      )}

    </>
  );
};

export default Filing;

